"use client";
import { useEffect, useState } from "react";
import { CircularProgress } from "@mui/material";
import Image from "next/image";
import { useTranslation } from "react-i18next";
import BlogCard from "./blogCard";
import { RootGraphQLPosts } from "@/app/[lng]/(use-auth)/blog/[slug]/types";
import CastilloCardona from "@/assets/images/blog/Castillo-de-cardona-medieval-cataluna.webp";
import CataDeVinos from "@/assets/images/blog/Cata-de-vinos-Vee.webp";
import Fitur2024 from "@/assets/images/blog/Fitur-2024-Ifema.webp";
import MuseoAtlantico from "@/assets/images/blog/museo-submarino-lanzarote.webp";
import AbonoRenfe from "@/assets/images/blog/oferta-renfe-2023.webp";
import PaseoEnBici from "@/assets/images/blog/Paseo-en-bici-con-Vee.webp";
import ViaFerrataCanals from "@/assets/images/blog/Via-ferrata-Serra-de-les-Canals.webp";
import VisitaBodega from "@/assets/images/blog/Visita-bodega-Vee.webp";
import BarcelonaAerea from "@/assets/images/blog/vista-aerea-Barcelona.webp";
import RightBlogDecorator from "@/assets/images/decorators/right-blog-decorator.webp";
import ArrowRight from "@/assets/images/icons/arrow-right.svg";
import arrowRight from "@/assets/images/icons/whiteArrow.svg";
import CustomButton from "@/common/customElements/button";
import {
  AbsoluteDiv,
  CircularDiv,
  CustomDiv,
  InlineDiv,
  VerticalCenterDiv,
} from "@/common/divs";
import { AlmostBoldText, SemiBoldText } from "@/common/texts";
import { useScroll } from "@/hooks/useScroll";
import { PRIMARY_BUTTON_COLOR } from "@/utils/constants";

const BlogEntries = ({ blogPosts }: { blogPosts: RootGraphQLPosts }) => {
  const { element, scrollBy, showRightArrow, showLeftArrow, SCROLL_WIDTH } =
    useScroll();
  const { t } = useTranslation();
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    if (blogPosts.data || blogPosts.errors) {
      setLoading(false);
    }
  }, [blogPosts]);
  return (
    <CustomDiv
      className="global-padding"
      paddingY="40px"
      style={{
        paddingLeft: "108px",
        position: "relative",
      }}
    >
      <InlineDiv className="inline-blog-div">
        <AlmostBoldText
          fontSize="20px"
          style={{ maxWidth: "550px", lineHeight: "55px" }}
        >
          {t("landing.interesting_themes")}
        </AlmostBoldText>

        <CustomButton
          marginY="7px"
          width="197px"
          height="50px"
          backgroundColor={PRIMARY_BUTTON_COLOR}
          onClick={() => null}
        >
          <InlineDiv className="centerDiv">
            <SemiBoldText fontSize="14px">{t("home.see_more")}</SemiBoldText>
            <Image
              src={ArrowRight.src}
              alt="Arrow Right"
              width={18}
              height={18}
              style={{ width: "18px", height: "18px", marginTop: "3px" }}
            />
          </InlineDiv>
        </CustomButton>
      </InlineDiv>
      {loading ?
        <CircularProgress size={24} />
      : <InlineDiv
          ref={element}
          className={"activityCarousel blog-carousel-style"}
        >
          {/* {!blogPosts.errors
            ? blogPosts.data.posts.edges.map((blogPost) => {
                return (
                  <BlogCard
                    key={blogPost.node.id}
                    imageUrl={Fitur2024.src}
                    title={blogPost.node.title}
                    tag="Proveedores, Viajero"
                    description="Vee en Fitur 2024: Ampliando horizontes y conectando con el Turismo Nacional"
                    link={process.env.NEXT_PUBLIC_CMS_URL + "fitur-2024"}
                  />
                );
              })
            : null} */}
          <BlogCard
            imageUrl={Fitur2024.src}
            title="Fitur 2024"
            tag="Proveedores, Viajero"
            description="Vee en Fitur 2024: Ampliando horizontes y conectando con el Turismo Nacional"
            link={process.env.NEXT_PUBLIC_CMS_URL + "fitur-2024"}
          />
          <BlogCard
            imageUrl={MuseoAtlantico.src}
            title="Museo Atlántico de Lanzarote"
            tag="Actividades"
            description="Arte submarino: Museo Atlántico de Lanzarote"
            link={
              process.env.NEXT_PUBLIC_CMS_URL + "museo-atlantico-de-lanzarote"
            }
          />
          <BlogCard
            imageUrl={PaseoEnBici.src}
            title="Paseo en bicicleta"
            tag="Actividades"
            description="Paseo en bicicleta: ¡explora el mundo con Vee!"
            link={process.env.NEXT_PUBLIC_CMS_URL + "paseo-en-bicicleta-2"}
          />
          <BlogCard
            imageUrl={ViaFerrataCanals.src}
            title="Vía ferrata Serra de les Canals"
            tag="Actividades"
            description="Descubriendo la emoción de la vía ferrata Serra de les Canals"
            link={
              process.env.NEXT_PUBLIC_CMS_URL +
              "via-ferrata-serra-de-les-canals"
            }
          />
          <BlogCard
            imageUrl={CataDeVinos.src}
            title="Cata de vinos"
            tag="Actividades"
            description="Cata de vinos: Descubre los sabores y aromas del vino"
            link={process.env.NEXT_PUBLIC_CMS_URL + "cata-de-vinos"}
          />
          <BlogCard
            imageUrl={AbonoRenfe.src}
            title="Abono Renfe verano 2023"
            tag="Viajeros"
            description="¡Descubre la oferta de Renfe para el Verano 2023!"
            link={process.env.NEXT_PUBLIC_CMS_URL + "abono-renfe-verano-2023"}
          />
          <BlogCard
            imageUrl={VisitaBodega.src}
            title="Visita a bodega"
            tag="Destinos"
            description="En Vee, la App marketplace de actividades turísticas y de ocio, te invitamos a embarcarte en una emocionante aventura de visitar bodegas."
            link={process.env.NEXT_PUBLIC_CMS_URL + "visita-bodega"}
          />
          <BlogCard
            imageUrl={BarcelonaAerea.src}
            title="Barcelona vista aérea"
            tag="Destinos"
            description="Barcelona siempre cautiva a sus visitantes con su arquitectura impresionante, playas doradas y rica historia"
            link={process.env.NEXT_PUBLIC_CMS_URL + "barcelona-vista-aerea"}
          />
          <BlogCard
            imageUrl={CastilloCardona.src}
            title="Castillo de Cardona"
            tag="Destinos"
            description="Descubre el Castillo de Cardona, en Cataluña"
            link={process.env.NEXT_PUBLIC_CMS_URL + "castillo-de-cardona"}
          />
        </InlineDiv>
      }
      {showLeftArrow && (
        <VerticalCenterDiv left="20px">
          <CircularDiv
            background={PRIMARY_BUTTON_COLOR}
            width="56px"
            height="56px"
            paddingX="11px"
            className="carousel-button-blog"
            onClick={() => {
              scrollBy({ left: -SCROLL_WIDTH, behavior: "smooth" });
            }}
          >
            <Image
              width={12}
              height={19}
              src={arrowRight}
              style={{ rotate: "180deg", width: "12px", height: "19px" }}
              alt="arrowRight"
            />
          </CircularDiv>
        </VerticalCenterDiv>
      )}
      {showRightArrow && (
        <VerticalCenterDiv right="20px" style={{ zIndex: "9" }}>
          <CircularDiv
            background={PRIMARY_BUTTON_COLOR}
            width="56px"
            height="56px"
            paddingX="11px"
            className="carousel-button-blog"
            onClick={() => {
              scrollBy({ left: SCROLL_WIDTH, behavior: "smooth" });
            }}
          >
            <Image
              width={12}
              height={19}
              src={arrowRight}
              alt="arrowRight"
              style={{ width: "12px", height: "19px" }}
            />
          </CircularDiv>
        </VerticalCenterDiv>
      )}
      <AbsoluteDiv
        className="hide-decorators"
        right="0px"
        style={{ top: "-100px" }}
      >
        <Image
          style={{ width: "300px", height: "auto" }}
          src={RightBlogDecorator}
          width={0}
          height={0}
          alt="Right Header Decorator"
          priority={true}
        />
      </AbsoluteDiv>
    </CustomDiv>
  );
};

export default BlogEntries;
